import { connect } from 'react-redux';
import { compose } from 'redux';
import PanelTextFill from '../../components/handoff/PanelTextFill';
import onlyIf from '../../hocs/onlyIf';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        color: handoff.getTextColor(element),
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.color.length; }))(PanelTextFill);
